import ReactModal from 'react-modal';
import React from 'react';

const DeleteCredit = ({ isOpen, onConfirm, onDecline }) => (
  <ReactModal
    appElement={document.getElementById('root')}
    isOpen={isOpen}
    contentLabel="Minimal Modal Example"
    portalClassName="AdjustmentCreditPortal"
    overlayClassName="AdjustmentCreditModal__Overlay"
    className="AdjustmentCreditModal__Content"
  >
    <div className="modal-header">
      <span className="close" onClick={onDecline}>
        &times;
      </span>
      <h2>Confirm Delete Credit</h2>
    </div>
    <div className="modal-body">
      <p>Are you sure you want to DELETE this credit?</p>
    </div>
    <div className="modal-footer">
      <button className="btn btn-primary" onClick={onConfirm}>
        Yes, delete
      </button>
      <button className="btn" onClick={onDecline}>
        No, never mind
      </button>
    </div>
  </ReactModal>
);

export default DeleteCredit;
